import { create } from 'zustand';
import * as lazisnuService from '../services/lazisnuService';

const useLazisnuTransactionStore = create((set, get) => ({
  transactions: [],
  loading: false,
  error: null,

  fetchTransactions: async () => {
    set({ loading: true, error: null });
    try {
      const data = await lazisnuService.getLazisnuTransactions();
      set({ transactions: data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  addPenerimaanInfak: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await lazisnuService.createPenerimaanInfak(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  addPenerimaanZakat: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await lazisnuService.createPenerimaanZakat(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  addPenerimaanDanaAmil: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await lazisnuService.createPenerimaanDanaAmil(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  addPenyaluran: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await lazisnuService.createPenyaluran(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  addBebanPengelolaan: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await lazisnuService.createBebanPengelolaan(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  updateTransaction: async (id, transactionData) => {
    set({ loading: true, error: null });
    try {
      await lazisnuService.updateLazisnuTransaction(id, transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },

  removeTransaction: async (id) => {
    set({ loading: true, error: null });
    try {
      await lazisnuService.deleteLazisnuTransaction(id);
      set((state) => ({
        transactions: state.transactions.filter((t) => t.id !== id),
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error; // Re-throw to allow component to catch
    }
  },
}));

export default useLazisnuTransactionStore;